import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Send to console for now — could be wired to a logging service
    // eslint-disable-next-line no-console
    console.error("Primordeia ErrorBoundary caught:", error, info);
  }

  handleRefresh = () => {
    try { window.location.reload(); } catch { /* ignore */ }
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          background: "linear-gradient(180deg, #F4F1E8 0%, #F1EDE2 100%)",
          fontFamily: "'Nunito', 'Segoe UI', sans-serif"
        }}
        data-testid="error-boundary-fallback"
      >
        <div
          style={{
            maxWidth: "440px",
            width: "100%",
            background:
              "repeating-linear-gradient(90deg, #b48856 0px, #ad8150 32px, #8c6736 44px, #a67d4a 58px, #b48856 70px)",
            borderRadius: "32px",
            padding: "44px 32px",
            textAlign: "center",
            boxShadow: "0 0 0 5px #5a4020, 0 0 0 8px #3e2b14, 0 24px 64px rgba(0,0,0,0.35)"
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "12px" }} aria-hidden="true">
            &#x1F33F;&#x1F407;&#x1F33F;
          </div>
          <div
            style={{
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "0.32em",
              textTransform: "uppercase",
              color: "#f7e7c1",
              fontFamily: "'Cinzel', serif",
              textShadow: "0 1px 0 #3a2a12",
              marginBottom: "8px"
            }}
          >
            A Word From Berry Kiss Cottage
          </div>
          <div
            style={{
              height: "2px",
              width: "40%",
              margin: "0 auto 20px",
              background: "linear-gradient(90deg, transparent, #f7e7c1, transparent)",
              opacity: 0.6
            }}
          />
          <p
            style={{
              fontSize: "16px",
              fontWeight: 600,
              lineHeight: 1.55,
              color: "#2a1a08",
              fontFamily: "'Cinzel', serif",
              marginBottom: "24px"
            }}
          >
            &ldquo;Something stirred in the cottage &mdash; refreshing.&rdquo;
          </p>
          <button
            onClick={this.handleRefresh}
            type="button"
            style={{
              padding: "12px 28px",
              borderRadius: "999px",
              background: "linear-gradient(135deg, #3e2b14 0%, #6a4a26 100%)",
              color: "#f7e7c1",
              fontFamily: "'Cinzel', serif",
              fontWeight: 700,
              fontSize: "12px",
              letterSpacing: "0.24em",
              textTransform: "uppercase",
              border: "1px solid #2a1a08",
              cursor: "pointer",
              boxShadow: "0 6px 18px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,230,180,0.2)"
            }}
            data-testid="error-boundary-refresh"
          >
            Tap to Refresh
          </button>
          {this.state.error && (
            <div
              style={{
                marginTop: "16px",
                fontSize: "10px",
                color: "rgba(58,42,18,0.55)",
                fontFamily: "monospace",
                wordBreak: "break-word"
              }}
            >
              {String(this.state.error.message || this.state.error).slice(0, 200)}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
